enum LinkType {
    LINK = 'link',
    LARGE_LINK = 'large-link',
    BUTTON_STANDARD_POSITIVE = 'button--positive',
    BUTTON_STANDARD_NEGATIVE = 'button--negative',
    BUTTON_LARGE_POSITIVE = 'button--large-positive',
    BUTTON_LARGE_NEGATIVE = 'button--large-negative',
    BUTTON_SMALL_POSITIVE = 'button--small-positive',
    BUTTON_SMALL_NEGATIVE = 'button--small-negative',
    INLINE = 'inline',
    RETURN = 'return',
    ICON = 'sgw-button button--icon',
}

export type LinkTypes = 'link' | 'button-positive' | 'button-negative' | 'inline' | 'return' | 'icon';

export type LinkSizes = 'small' | 'standard' | 'large';

export default LinkType;
